angular.module('bribac.views.editAgent', [
  'ngRoute',
  'bribac.translations',
  'bribac.values',
  'bribac.entities.kinds',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.services.errorUtils',
  'bribac.components.whenLoaded',
  'bribac.components.agentEditor'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/agent/:id/edit', {
      templateUrl: 'edit-agent-view.html',
      controller: 'EditAgentViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('EditAgentViewCtrl', function(
    $routeParams,
    $location,
    KINDS,
    api,
    state,
    setLocale,
    errorUtils,
    permissions
  ) {

    var $ctrl = this

    var id = parseInt($routeParams.id)

    if (!isFinite(id)) {
      // TODO: Should show 404 error instead. Should probably do this check in the $routeProvider config.
      return
    }

    $ctrl.onSubmit = function() {
      var $form = $ctrl.form

      if ($form._submitting) return
      if ($form.$invalid) {
        $form._submitError = 'formErrors.invalidFields'
        return
      }

      $form._submitting = true
      $form._submitError = ''

      api.put(KINDS.AGENT, $ctrl.editableAgent)
        .finally(function() {
          $form._submitting = false
        })
        .then(
          function success(request) {
            var agent = request.data
            if (agent.id === state.currentAgent.id) {
              state.currentAgent = agent
              state.currentAgent.permissions = permissions.getPermissionsForRole(agent.roles[0])
              setLocale(agent.locale)
            }
            $location.url('/agent/' + agent.id)
          },

          function error(request) {
            $form._submitError = errorUtils.parseErrorResponse(request)
          }
        )
    }

    // Init

    $ctrl.agentPromise = api.get(KINDS.AGENT, id).then(function(request) {
      $ctrl.agent = request.data
      $ctrl.editableAgent = angular.copy($ctrl.agent)
    })

  })
